import { render, staticRenderFns } from "./ListSamplesTable.vue?vue&type=template&id=86fcfa7c"
import script from "./ListSamplesTable.vue?vue&type=script&lang=js"
export * from "./ListSamplesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports